<template>
	<div class="dropdown-c" :class="{ full: full }" @click="toggle">
		<div class="selected-c" :class="[selectedClass, { 'is-placeholder': !value }]">
			{{ selectedLabel }}
			<span class="arrow">
				<IconArrow :direction_prop="arrowDirection" />
			</span>
		</div>

		<ul v-if="open" class="menu">
			<li v-for="option in options" :key="option.value" @click.stop="select(option)" :class="['item', option.class]">
				{{ option.label }}
			</li>
		</ul>
	</div>
</template>

<script>
import IconArrow from './icons/IconArrow.vue'

export default {
	name: "DropdownSimple",

	components: {
		IconArrow
	},

	props: {
		value: null, // v-model

		/**
		 * List of dropdown options
		 * @type {Array<{
		 *   value: string|number,
		 *   label: string,
		 *   class?: string|string[]|Object
		 * }>}
		 */
		options: {
			type: Array,
			required: true
		},

		placeholder: {
			type: String,
			default: "Select one"
		},

		// Full width
		full: {
			type: Boolean,
			default: false
		},

		// Custom class for selected
		selectedClass: {
			type: [String, Array, Object],
			default: ""
		}
	},
	data() {
		return {
			open: false
		}
	},
	computed: {
		arrowDirection() {
			if (this.open) {
				return 'up'
			} else {
				return 'down'
			}
		},

		selectedLabel() {
			const found = this.options.find(
				function (o) {
					return o.value === this.value
				}.bind(this)
			)
			return found ? found.label : this.placeholder
		}
	},
	methods: {
		toggle() {
			this.open = !this.open
		},
		select(option) {
			this.$emit("input", option.value)
			this.open = false
		}
	}
}
</script>

<style scoped>
.dropdown-c {
	position: relative;
	display: inline-block;
	cursor: pointer;
}

.dropdown-c.full {
	display: block;
	width: 100%;
}

.selected-c {
	padding: 0;
	background: transparent;
	color: #fff;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.arrow {
	margin-left: 0.5rem;
}

.menu {
	position: absolute;
	top: 100%;
	left: 0;
	width: 100%;
	background: #1f2937;
	list-style: none;
	margin: 0.625rem 0 0 0;
	padding: 0;
	border-radius: 0.375rem;
	overflow: hidden;
	z-index: 10;
}

.item {
	padding: 0.625rem;
	color: #fff;
}

.item:hover {
	background: #374151;
}

.is-placeholder {
	color: var(--color-grey8);
}
</style>